import { render, staticRenderFns } from "./PatientGeneralInfoItem.vue?vue&type=template&id=fa5b90ec&"
import script from "./PatientGeneralInfoItem.vue?vue&type=script&lang=js&"
export * from "./PatientGeneralInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports